export enum EnumTipoPessoaContato {
    TELEFONE = 0,
    EMAIL = 1,
}